import { Component, OnInit, ViewChild, Renderer, ElementRef } from '@angular/core';
import { FormService } from '../form.service';

declare var $:any;
declare var jQuery:any;

@Component({
  selector: 'hc-screen-intro',
  templateUrl: './screen-intro.component.html'
})
export class ScreenIntroComponent implements OnInit {

  constructor(
    private form : FormService,
    private renderer : Renderer
  ) { }

  @ViewChild('slider') slider;

  ngOnInit() {}

  ngAfterViewInit() {
    this.triggerClicks();
  }

  timeout1:any = null;
  timeout2:any = null;
  timeout3:any = null;
  timeout4:any = null;

  triggerClicks() {

    this.form.isIntro = true;

    let element = $(this.slider.sliderElement.nativeElement);
    let offset  = element.offset();
    let width   = element.outerWidth();
    let height  = element.height();

    $('#introAnimations').css('top',    offset.top);
    $('#introAnimations').css('width',  width);
    $('#introAnimations').css('margin-left', '-' + (width / 2) + 'px');
    $('#introAnimations').css('height', height);

    let positions = $('.pos');
    let handElem  = $('.hand');
    let pos1 = $(positions[0]);
    let pos2 = $(positions[1]);

    handElem.fadeOut();

    setTimeout(() => {
      handElem.fadeIn();
    }, 700);

    this.timeout1 = setTimeout(() => {
      handElem.css('left', pos1.css('left'));
      handElem.css('top',  pos1.css('top'));
    }, 900);

    this.timeout2 = setTimeout(() => {
      handElem.css('left', pos2.css('left'));
      handElem.css('top',  pos2.css('top'));
    }, 2900);

    this.timeout3 = setTimeout(() => {
      handElem.css('left', '50%');
      handElem.css('top', '100%');
    }, 4900);

    this.timeout4 = setTimeout(() => {
      $('#introAnimations').fadeOut();
      this.form.isIntro = false;
    }, 6000);

  }

  replayedEvent:boolean = false;

  disableIntro(range) {


    this.form.selectedRange = range;
    this.form.isIntro = false;

    $('#introAnimations').css('opacity', 0).hide().remove();
    if (this.timeout1 != null) clearTimeout(this.timeout1);
    if (this.timeout2 != null) clearTimeout(this.timeout2);
    if (this.timeout3 != null) clearTimeout(this.timeout3);
    if (this.timeout4 != null) clearTimeout(this.timeout4);
  }

  receiveRange(event) {
    this.form.selectedRange = event;
  }

  submitEmoji() {
    this.form.screen = 'feedback';
  }

}



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/screen-intro/screen-intro.component.ts